import { ImagePrimitive } from '@arpeggi/ui'
import { ComponentProps, FC } from 'react'
import { PlayerWrapper } from '../primitives'

interface Props {
  coverImageUrl?: string
}

export const ArpCoverArt: FC<Props & ComponentProps<typeof PlayerWrapper.Root>> = ({
  coverImageUrl, ...rest
}) => (
  <PlayerWrapper.Root {...rest}>
    <PlayerWrapper.Content>
      <ImagePrimitive.Root
        css={{ width: '100%', height: '100%', borderRadius: 'inherit', background: 'transparent' }}
      >
        <ImagePrimitive.Image src={coverImageUrl} />
      </ImagePrimitive.Root>
    </PlayerWrapper.Content>
  </PlayerWrapper.Root>
)
